module.exports = __webpack_public_path__ + "assets/normal/images/ComEmpty_3.7f6df146.png";